import binary from '@/helpers/rave/constants/toneBinaries'

export default {
  [binary.SPLENIC]: 'Splenic (Concentrated)',
  [binary.AJNA]: 'Ajna (Periodic)',
  [binary.SOLAR_PLEX]: 'Solar Plexus (Cyclical)'
}
